
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { getDrupozTitle } from '../../../reducers/drupoz';
import { getParName } from '../../../reducers/par';

import ToolLinks from '../ToolLinks';
import ObjectInfoValues from '../ObjectInfoValues';
import LinkToTeleso from './LinkToTeleso';

const classNames = mergeStyleSets({
    root: {
    },
    vymera: {
        fontWeight: 600
    }
});

const IsknParInfo = ({isknDate, data, showTelLink=true, tools}) => {

    const par = data.par[0];
    const tel = data.tel.reduce((previous, current) => {
        return (current.tel_id === par.tel_id)
            ? current
            : previous;
    }, null);

    const drupozTitle = useSelector(state => getDrupozTitle(state.drupoz, par.drupoz_kod));

    return (
        <React.Fragment>
            <ObjectInfoValues items={[
                {
                    title: 'Katastrální území',
                    value: `${par.katuze_name} (${par.katuze_kod})`
                },
                {
                    title: 'Parcelní číslo',
                    value: getParName(par)
                },
                {
                    title: 'Číslo LV',
                    value: showTelLink
                        ? (tel ? <LinkToTeleso isknDate={isknDate} tel={tel} /> : 'Není na LV' )
                        : (tel ? `${tel.cislo_tel}` : `Není na LV` )
                },
                {
                    title: 'Výměra',
                    value: <span className={classNames.vymera}>{par.vymera_parcely} m<sup>2</sup></span>
                },
                {
                    title: 'Typ parcely',
                    value: par.par_type
                },
                {
                    title: 'Druh pozemku',
                    value: drupozTitle
                }
            ]}/>

            <ToolLinks
                tools={tools}
                par={par}
            />

        </React.Fragment>
    );
}

export default IsknParInfo;
